import { useState } from "react";

import Tag from "./Tag";
import { truncateName } from "../../util/stringUtils";

const MAX_VISIBLE_TAGS = 2;
const resolveTagId = (tag) =>
  tag?.tag_id ?? tag?.id ?? tag?.tag?.tag_id ?? tag?.tag?.id;

const TagsOverflow = ({ selectedTags, handleTagRemove }) => {
  const [isOverflowOpen, setIsOverflowOpen] = useState(false);

  const tags = selectedTags ?? [];
  const visibleTags = tags.slice(0, MAX_VISIBLE_TAGS);
  const overflowTags = tags.slice(MAX_VISIBLE_TAGS);
  const overflowCount = overflowTags.length;

  return (
    <>
      {visibleTags.map((tag) => (
        <Tag
          tag={tag}
          key={resolveTagId(tag) ?? tag?.name}
          handleTagRemove={handleTagRemove}
        />
      ))}
      {overflowCount > 0 && (
        <div
          className="tags-overflow-wrapper"
          onMouseEnter={() => setIsOverflowOpen(true)}
          onMouseLeave={() => setIsOverflowOpen(false)}
          onFocus={() => setIsOverflowOpen(true)}
          onBlur={() => setIsOverflowOpen(false)}
          tabIndex={0}
        >
          <div className="tags-overflow-trigger">+{overflowCount}</div>
          {isOverflowOpen && (
            <div className="tags-overflow-list" role="tooltip">
              {overflowTags.map((tag) => (
                <div
                  key={resolveTagId(tag) ?? tag?.name}
                  className="tags-overflow-item"
                >
                  {truncateName(tag.name)}
                  {handleTagRemove && (
                    <span
                      className="tag-delete-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTagRemove(resolveTagId(tag), tag);
                      }}
                    >
                      &times;
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TagsOverflow;
